module.exports = __webpack_public_path__ + "static/media/citrus-fruit.df12a5bf.jpg";